import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App'; 
import * as serviceWorker from './serviceWorker';

import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'

import allReducer from './reducers'
import { Provider } from 'react-redux'
import getTheAllApiSaga from './sagas'

 
const sagaMiddleware = createSagaMiddleware()


const myStore = createStore(
        allReducer,
        applyMiddleware(sagaMiddleware),
        // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
     );

// then run the saga
sagaMiddleware.run(getTheAllApiSaga);


ReactDOM.render( 
  <React.StrictMode> 
      <Provider store={myStore}>
          <App />
      </Provider> 
  </React.StrictMode>,
  document.getElementById('doctor-app-root')
);
 
serviceWorker.unregister();
